module.exports = __webpack_public_path__ + "img/header_lg.50b39e26.jpg";